
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/illustrations/search/[search]",
      function () {
        return require("private-next-pages/illustrations/search/[search].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/illustrations/search/[search]"])
      });
    }
  